/**
 * Converts old LegacyFirstRunData object into new FirstRunState object.
 * This process mainly removes old unused properties that may be on LegacyFirstRunData object.
 */
export function transformLegacyDataToStateFormat(data) {
    return {
        CompletedFirstRun: data.CompletedFirstRun,
        Version: data.Version,
    };
}
//# sourceMappingURL=transformLegacyDataToStateFormat.js.map